import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React from "react";
import {
  durationList,
  getLastNMonths,
  prepareModificationsMLCD,
  sizes,
  valueTypeList,
} from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  getModificationsData,
  getScenariosMod,
  getSkuPgMod,
  setState,
} from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
  const [validate, setValidate] = useState({
    countryValidated: false,
    scenarioValidated: false,
    productValidated: false,
    durationValidated: false,
    valueTypeValidated: false,
  });
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const [countryMod, setCountryMod] = useState("");
  const [scenarioMod, setScenarioMod] = useState("");

  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const {
    countries,
    selectedCountry,
    selectedCountryID,

    isActiveScenario,

    selectedAnalysisTypeID,

    scenariosMod,
    selectedScenarioName,
    selectedScenarioID,

    skuPgsMod,
    selectedSkuPgName,
    selectedSkuPgID,

    duration,

    selectedValueType,
    modificationsCustomers,
  } = state;

  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  let skuPgsArr = skuPgsMod.filter((item) => item.packGroupOrSKUName !== "All");

  useEffect(() => {
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("duration", null));
    dispatch(setState("selectedValueType", ""));
    dispatch(setState("clearAnalyzeModifications", false));

    dispatch(setState("scenariosMod", []));
    dispatch(setState("skuPgsMod", []));

  }, []);

  const clearValuesForCountry = () => {
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("selectedValueType", ""));
  };

  const clearValuesForScenario = () => {
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("selectedValueType", ""));
  };

  useEffect(() => {
    if (countryMod !== "") {
      getScenariosForCountry();
    }
  }, [countryMod]);

  useEffect(() => {
    if (scenarioMod !== "") {
      getSkuPgForScenario();
    }
  }, [scenarioMod]);

  function setCountry(event) {
    const name = event.target.value;
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;
    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));

    setCountryMod(name);

    clearValuesForCountry();

    dispatch(setState("clearAnalyzeModifications", false));
    dispatch(setState("modificationData", null));
  }

  useEffect(() => {
    if (globalSelectedCountryID !== null) {
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
    }
  }, [globalSelectedCountryID]);

  useEffect(() => {
    if (globalSelectedCountryName !== null) {
      dispatch(setState("selectedCountry", globalSelectedCountryName));
    }
  }, [globalSelectedCountryName]);

  function getScenariosForCountry() {
    const countryID = selectedCountryID;
    const activeScenario = isActiveScenario;
    const analyisID = selectedAnalysisTypeID;
    const obj = {
      countryID,
      activeScenario,
      analyisID,
    };
    dispatch(getScenariosMod(obj));
  }

  function setScenario(event) {
    const id = event.target.value;
    const name = scenariosMod.find(
      (scenario) => scenario.scenarioID === id
    ).scenarioName;
    if (name) {
      setValidate({
        ...validate,
        scenarioValidated: true,
      });
    }

    dispatch(setState("selectedScenarioName", name));
    dispatch(setState("selectedScenarioID", id));

    setScenarioMod(id);

    clearValuesForScenario();
  }

  function getSkuPgForScenario() {
    const scenarioID = selectedScenarioID;
    const obj = {
      scenarioID,
    };

    dispatch(getSkuPgMod(obj));
  }

  function setSkuPg(event) {
    const name = event.target.value;
    let id = "";
    if (name === "All") {
      id = 0;
    } else {
      id = skuPgsArr.find(
        (item) => item.packGroupOrSKUName === name
      ).packGroupOrSKUID;
    }

    if (name) {
      setValidate({
        ...validate,
        productValidated: true,
      });
    }

    dispatch(setState("selectedSkuPgName", name));
    dispatch(setState("selectedSkuPgID", id));
  }

  function setDuration(event) {
    const d = event.target.value;
    dispatch(setState("duration", d));
    const periods = getLastNMonths(d);
    if (d) {
      setValidate({
        ...validate,
        durationValidated: true,
      });
    }
    dispatch(setState("modificationsPeriods", periods));
  }

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  function setValueType(event) {
    const type = event.target.value;
    if (type) {
      setValidate({
        ...validate,
        valueTypeValidated: true,
      });
    }
    dispatch(setState("selectedValueType", type));
  }

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [2000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  function handleDisplay() {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (selectedScenarioName === null || selectedScenarioName === "") {
      displayAlert("Scenario");
      return;
    }
    if (selectedSkuPgName === null || selectedSkuPgName === "") {
      displayAlert("SKU");
      return;
    }
    if (duration === null || duration === "") {
      displayAlert("Duration");
      return;
    }
    if (selectedValueType === null || selectedValueType === "") {
      displayAlert("Value Type");
      return;
    }


    const obj = {
      scenarioID: selectedScenarioID,
      valueType: selectedValueType,
      duration: duration,
      packID: selectedSkuPgID,
    };

    dispatch(setState("modificationsData", null));
    dispatch(setState("modificationsTD", null));
    dispatch(setState("clearAnalyzeModifications", true));
    
    dispatch(setState("selectedDataPointsForModification", []));
    dispatch(setState("currentPageFlag", true));

    dispatch(getModificationsData(obj));
  }

  return (
    <Box sx={{ mt: 3, mb: 4 }}>
      <Grid container columnGap={2} rowGap={2}>
        <Grid item sx={{ minWidth: "200px" }}>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={countryMod}
              label="Country"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setCountry}
            >
              {countries.map((country, index) => {
                return (
                  <MenuItem key={index} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sx={{ minWidth: "200px" }}>
          <FormControl>
            <InputLabel>Scenario</InputLabel>
            <Select
              value={scenarioMod}
              label="Scenario"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setScenario}
            >
              {scenariosMod.map((scenario, index) => {
                return (
                  <MenuItem key={index} value={scenario.scenarioID}>
                    {scenario.scenarioName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl item sx={{ minWidth: "430px" }}>
            <InputLabel>Product</InputLabel>
            <Select
              value={selectedSkuPgName}
              label="Product"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setSkuPg}
            >
             {skuPgsArr.length > 0 ? <MenuItem key={"All"} value={"All"}>
                All
              </MenuItem> : null}
              {skuPgsArr.map((skuPg, index) => {
                return (
                  <MenuItem key={index} value={skuPg.packGroupOrSKUName}>
                    {skuPg.packGroupOrSKUName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Duration</InputLabel>
            <Select
              value={duration}
              label="Duration"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setDuration}
            >
              {durationList.map((duration, index) => {
                return (
                  <MenuItem key={index} value={duration.value}>
                    {duration.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Value Type</InputLabel>
            <Select
              value={selectedValueType}
              label="Value Type"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setValueType}
            >
              {valueTypeList.map((type, index) => {
                return (
                  <MenuItem key={index} value={type.value}>
                    {type.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <Button
            startIcon={<ManageSearchIcon />}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 0.3,
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}
            onClick={handleDisplay}
          >
            Search Customers
          </Button>
        </Grid>
      </Grid>
      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
      <Divider sx={{ mt: 3 }} />
    </Box>
  );
}
